import React, { useState, useEffect } from "react";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import Button from "@material-ui/core/Button";
import Pagination from "@material-ui/lab/Pagination";
import Snackbar from "@material-ui/core/Snackbar";
import Grid from "@material-ui/core/Grid";
import MuiAlert from "@material-ui/lab/Alert";
import { Formik } from "formik";
import SearchIcon from "@material-ui/icons/Search";
import EditIcon from "@material-ui/icons/Edit";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import { CircularProgress } from "@material-ui/core";
import Loader from "../Global/Loader/Index";
import AlertMessage from "../Global/Message/Alert";
import { Link } from "react-router-dom"
import ScrollableAnchor from 'react-scrollable-anchor'
import { removeHash, goToAnchor, goToTop } from 'react-scrollable-anchor'

const useStyles = makeStyles((theme) => ({
    icon: {
        float: "left",
    },
    btn: {
        padding: theme.spacing(1.2),
        backgroundColor: "transparent",
        fontWeight: "700",
        maxWidth: "230px",
        borderRadius: "10px",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "transparent",
            boxShadow: "none",
        },
        color: "#3B3B3B",
        width: "100%",
    },
    btnActive: {
        padding: theme.spacing(1.2),
        borderRadius: "10px",
        maxWidth: "230px",
        backgroundColor: "#950000",
        fontWeight: "700",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#950000",
            boxShadow: "none",
        },
        color: "#fff",
        width: "100%",
    },
    grayBox: {
        backgroundColor: "#F3F3F3",
        width: '100%'
    },
    grayerBox: {
        backgroundColor: "#DFDFDF",
    },
    paperNoBg: {
        backgroundColor: "transparent",
    },
    mr: {
        marginLeft: "5px",
    },
}))

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ProductsList = ({ history, pid, tPage, mainCat, subCat, secCat }) => {

    const classes = useStyles();
    const searchURL1 = history.location.search
    const [pageLoading, setPageLoading] = useState(true);
    const [reqPageNumber, setReqPageNumber] = useState((tPage > 1) ? tPage : 1);
    const [searchedKeyword, setSearchedKeyword] = useState(new URLSearchParams(searchURL1).get("keyword") || "")
    const [selectedMainCat, setSelectedMainCat] = useState(mainCat)
    const [selectedSubCat, setSelectedSubCat] = useState(subCat)
    const [selectedSecCat, setSelectedSecCat] = useState(secCat)
    const [mainCats, setMainCats] = useState([]);
    const [subCats, setSubCats] = useState([]);
    const [secCats, setSecCats] = useState([]);
    const [productList, setProductList] = useState([]);
    const [pages, setPages] = useState(1);
    const [open, setOpen] = useState(false);
    const [id, setId] = useState(0);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [loadings, setLoadings] = useState({
        load1: false,
        load2: false,
        load3: false,
    });
    const [alert, setAlert] = useState({
        open: false,
        type: "success",
        message: "",
    });

    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    const handleClose = () => {
        setOpen(false);
        setId("");
    };

    const toggleOpenAlert = (Type, msg) => {
        setAlert({
            open: true,
            type: Type,
            message: msg,
        });
    };

    const toggleCloseAlert = () => {
        setAlert({ open: false, type: alert.type, message: alert.message });
    };

    const initLoad = () => {
        const searchURL4 = history.location.search
        let sk = new URLSearchParams(searchURL4).get("keyword") || ""
        setSearchedKeyword(sk)
        if (searchedKeyword !== '' || sk !== '') {
            if (searchedKeyword !== '')
                getProducts(reqPageNumber, 0, 0, 0, searchedKeyword)
            else
                getProducts(reqPageNumber, 0, 0, 0, sk)

        }
        else {

            if (selectedMainCat === 0) {

                getProducts(reqPageNumber, 0, 0, 0)

            }
            else {

                if (selectedMainCat !== 0)
                    handleCatAxios(1, selectedMainCat, false, false)

                if (selectedSubCat !== 0)
                    handleCatAxios(2, selectedSubCat, false, false)

                getProducts(reqPageNumber, selectedMainCat, selectedSubCat, selectedSecCat)

            }

        }


    }

    const deleteProduct = async () => {
        setDeleteLoading(true);
        let formData = new FormData();
        formData.append("ProductId", id);
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };
        try {
            const { data } = await axios.post(
                `/api/admin/products/delete`,
                formData,
                config
            );
            if (data.status === "ok") {
                toggleOpenAlert("success", "محصول مورد نظر با موفقیت حذف شد");
                initLoad()
                handleClose();
                setDeleteLoading(false);
            }
            if (data.status === "error") {
                toggleOpenAlert("error", "مشکلی در حذف محصول پیش آمده است");
                handleClose();
                setDeleteLoading(false);
            }
        } catch (error) {
            console.error(error);
            toggleOpenAlert("error", "خطای ۱");
            //toggleOpenAlert("error", "خطا در اتصال با سرور");
            setDeleteLoading(false);
        }
    };

    const getCats = async () => {

        setLoadings({
            load1: true,
            load2: false,
            load3: false,
        });

        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };

        try {
            const { data } = await axios.get(
                "/api/products/getcategories?lan=fa",
                config
            );
            if (data.status === "ok") {
                setMainCats(data.data);
                setLoadings({
                    load1: false,
                    load2: false,
                    load3: false,
                });
            }
        } catch (e) {
            setLoadings({
                load1: false,
                load2: false,
                load3: false,
            });
        }
    };

    const getProducts = async (
        page,
        mainCategoryId,
        subCategoryId,
        secondarySubCategoryId,
        keyword = '',
    ) => {
        setPageLoading(true)
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };
        try {

            let url = `/api/admin/products?lan=fa&page=${page}`
            if (keyword !== '') {
                url += `&keyword=${keyword}`
            } else {

                if ((!isNaN(Number(mainCategoryId))) && (Number(mainCategoryId) !== 0)) {
                    url += `&mainCategoryId=${mainCategoryId}`
                }

                if ((!isNaN(Number(subCategoryId))) && (Number(subCategoryId) !== 0)) {
                    url += `&subCategoryId=${subCategoryId}`
                }

                if ((!isNaN(Number(secondarySubCategoryId))) && (Number(secondarySubCategoryId) !== 0)) {
                    url += `&secondarySubCategoryId=${secondarySubCategoryId}`
                }

            }

            const { data } = await axios.get(
                url,
                config
            );
            setProductList(data.data.productList);
            setPages(data.data.totalPages);
            const searchURL2 = history.location.search
            const land = new URLSearchParams(searchURL2).get("producttoland") || ""
            if (land !== "") {
                goToAnchor('p' + land, true)
            }
        } catch (error) {
            console.error(error);
            toggleOpenAlert("error", "خطای ۲");
            //toggleOpenAlert("error", "خطا در اتصال با سرور");
        }
        setPageLoading(false)
    };

    const handleChangePage = (event, value) => {

        setReqPageNumber(value);
        let url = `/profile/products-list/${value}`
        if (searchedKeyword !== '') {
            history.push({
                pathname: `${url}/`,
                search: `&keyword=${searchedKeyword}`,
            });
        } else {

            if ((!isNaN(Number(selectedMainCat))) && (Number(selectedMainCat) !== 0)) {
                url += `/${selectedMainCat}`
            }

            if ((!isNaN(Number(selectedSubCat))) && (Number(selectedSubCat) !== 0)) {
                url += `/${selectedSubCat}`
            }


            if ((!isNaN(Number(selectedSecCat))) && (Number(selectedSecCat) !== 0)) {
                url += `/${selectedSecCat}`
            }

            history.push({
                hash: "",
                pathname: url,
            })
        }
        if (searchedKeyword !== '')
            getProducts(value, 0, 0, 0, searchedKeyword)
        else
            getProducts(value, selectedMainCat, selectedSubCat, selectedSecCat)

        goToTop()
    }

    const handleCatAxios = async (type, catId, loadProducts = true, pushURL = true) => {

        let url = ""
        setSearchedKeyword('')
        if (type === 1) {

            url = "/api/products/getsubcategories?lan=fa&MainCategoryId="
            setSelectedMainCat(catId)
            if (pushURL) {
                history.push({
                    hash: "",
                    pathname: `/profile/products-list/1/${catId}`,
                })
            }
        }
        else if (type === 2) {

            setSelectedSubCat(catId)
            url = "/api/products/getsecondarysubcategories?lan=fa&SubCategoryId="
            if (pushURL) {
                history.push({
                    hash: "",
                    pathname: `/profile/products-list/1/${selectedMainCat}/${catId}`,
                })
            }
        }

        setLoadings({
            load1: false,
            load2: type === 1 ? true : false,
            load3: type === 2 ? true : false,
        });


        try {

            const config = {
                headers: {
                    Authorization: `Bearer ` + localStorage.getItem("token"),
                    "Content-Type": "application/json",
                },
            };

            const { data } = await axios.get(url + catId, config);

            if (data.status === "ok") {

                if (type === 1) {

                    setLoadings({
                        load1: false,
                        load2: false,
                        load3: false,
                    });
                    setSubCats(data.data)
                    if (loadProducts)
                        getProducts(1, catId, 0, 0)

                }
                else if (type === 2) {

                    setLoadings({
                        load1: false,
                        load2: false,
                        load3: false,
                    });
                    setSecCats(data.data)
                    if (loadProducts)
                        getProducts(1, selectedMainCat, catId, 0)
                }

            }
        } catch (e) {
            setLoadings({
                load1: false,
                load2: false,
                load3: false,
            });
        }
    }

    const handleSearch = (keyword) => {
        setSearchedKeyword(keyword)
        let url = '/profile/products-list/1'
        history.push({
            pathname: `${url}/`,
            search: `&keyword=${keyword}`,
        });
        getProducts(
            1,
            0,
            0,
            0,
            keyword,
        )
    }

    useEffect(() => {

        getCats()
        initLoad()

    }, []);

    const handleClickOpen = (id) => {
        setOpen(true);
        setId(id);
    };

    return (
        <>
            <Box borderRadius={10} mt={2} mr={2} className={classes.grayBox}>
                <Box className={classes.grayerBox} borderRadius={10}>
                    <Button className={classes.btnActive} variant="contained">لیست محصولات</Button>
                    <Link to="/profile/products-insert">
                        <Button className={classes.btn} variant="contained">درج محصول جدید</Button>
                    </Link>
                </Box>
                <br />
                <Grid container spacing={1}>
                    <Grid item md={3}>
                        <Box mt={0} p={1}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel id="demo-simple-select-outlined-label">
                                    {loadings.load1 ? (
                                        <CircularProgress size={12} />
                                    ) : (
                                        "دسته بندی"
                                    )}
                                </InputLabel>
                                <Select
                                    fullWidth
                                    name="category"
                                    labelId="demo-simple-select-outlined-label"
                                    id="demo-simple-select-outlined"
                                    onChange={(e) => {
                                        //handleChange(e);
                                        if (e.target.value !== "0") {
                                            setSubCats([]);
                                            setSecCats([]);
                                            setSelectedSubCat(0)
                                            setSelectedSecCat(0)
                                            setReqPageNumber(1)
                                            handleCatAxios(1, e.target.value);
                                        }
                                    }}
                                    label={
                                        loadings.load1 ? (
                                            <CircularProgress size={12} />
                                        ) : (
                                            "دسته بندی"
                                        )
                                    }
                                    value={selectedMainCat}>
                                    <MenuItem disabled value="0">
                                        <em> انتخاب کنید</em>
                                    </MenuItem>
                                    {mainCats.length > 0 &&
                                        mainCats.map((item) => (
                                            <MenuItem value={item.id.toString()}>
                                                {item.title}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </FormControl>
                        </Box>
                    </Grid>
                    <Grid item md={3}>
                        <Box mt={0} p={1}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel id="demo-simple-select-outlined-label">
                                    {loadings.load2 ? (
                                        <CircularProgress size={12} />
                                    ) : (
                                        "زیر مجموعه"
                                    )}
                                </InputLabel>
                                <Select
                                    fullWidth
                                    name="subCategory"
                                    value={selectedSubCat}
                                    labelId="demo-simple-select-outlined-label"
                                    id="demo-simple-select-outlined"
                                    onChange={(e) => {
                                        //handleChange(e);
                                        if (e.target.value !== "0") {
                                            setSecCats([]);
                                            setSelectedSecCat(0)
                                            setReqPageNumber(1)
                                            handleCatAxios(2, e.target.value);
                                        }
                                    }}
                                    label={
                                        loadings.load2 ? (
                                            <CircularProgress size={12} />
                                        ) : (
                                            "زیر مجموعه"
                                        )
                                    }>
                                    <MenuItem disabled value="0">
                                        <em> انتخاب کنید</em>
                                    </MenuItem>
                                    {subCats.length > 0 &&
                                        subCats.map((item) => (
                                            <MenuItem value={item.id.toString()}>
                                                {item.title}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </FormControl>
                        </Box>
                    </Grid>
                    <Grid item md={3}>
                        <Box mt={0} p={1}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel id="demo-simple-select-outlined-label">
                                    {loadings.load3 ? (
                                        <CircularProgress size={12} />
                                    ) : (
                                        "زیر مجموعه فرعی"
                                    )}
                                </InputLabel>
                                <Select
                                    fullWidth
                                    name="SecondarySubCategoryId"
                                    value={selectedSecCat}
                                    labelId="demo-simple-select-outlined-label"
                                    id="demo-simple-select-outlined"
                                    onChange={(e) => {
                                        //handleChange(e);
                                        if (e.target.value !== "0") {
                                            setSelectedSecCat(e.target.value)
                                            setReqPageNumber(1)
                                            history.push({
                                                hash: "",
                                                pathname: `/profile/products-list/1/${selectedMainCat}/${selectedSubCat}/${e.target.value}`,
                                            })
                                            getProducts(1, selectedMainCat, selectedSubCat, e.target.value)
                                        }
                                    }}
                                    label={
                                        loadings.load3 ? (
                                            <CircularProgress size={12} />
                                        ) : (
                                            "زیر مجموعه فرعی"
                                        )
                                    }>
                                    <MenuItem disabled value="0">
                                        <em> انتخاب کنید</em>
                                    </MenuItem>
                                    {secCats.length > 0 &&
                                        secCats.map((item) => (
                                            <MenuItem value={item.id.toString()}>
                                                {item.title}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </FormControl>
                        </Box>
                    </Grid>
                    <Grid item md={3}>
                        <Box mt={0} p={1}>
                            <Formik
                                enableReinitialize
                                initialValues={{ keyword: searchedKeyword }}
                                validate={(values) => {
                                    const errors = {};
                                    if (!values.keyword) {
                                        errors.keyword = "Required";
                                    }
                                    return errors;
                                }}
                                onSubmit={(values, { setSubmitting }) => {
                                    if (values.keyword.trim() !== "") {
                                        setPageLoading(true);
                                        handleSearch(values.keyword.trim())
                                    }
                                    setSubmitting(false);
                                }}>
                                {({
                                    values,
                                    errors,
                                    touched,
                                    handleChange,
                                    handleBlur,
                                    handleSubmit,
                                    isSubmitting,
                                }) => (
                                    <form
                                        onSubmit={handleSubmit}
                                        className="search-form productSearchForm"
                                        style={{ margin: "0px", width: "96%" }}
                                    >
                                        <input
                                            type="text"
                                            name="keyword"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder='جستجوی محصول'
                                            value={values.keyword}
                                            style={{ height: "38px", width: "calc(100% - 75px)" }}
                                            className="productListSearchInput" />
                                        <button
                                            type="submit"
                                            className="btnGreen"
                                            style={{ height: "58px", width: "56px" }}
                                            disabled={isSubmitting}>
                                            <SearchIcon />
                                        </button>
                                    </form>
                                )}
                            </Formik>
                        </Box>
                    </Grid>
                </Grid>
                <Box pt={4} pb={2} px={1}>
                    <Box
                        bgcolor="#950000"
                        borderRadius="10px 10px 0px 0px"
                        color="#fff"
                        p={2}
                        textAlign="center">
                        <Grid container>
                            <Grid xs={2}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%">
                                    تصویر محصول
                            </Box>
                            </Grid>
                            <Grid xs={2}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%">
                                    نام محصول
                            </Box>
                            </Grid>
                            <Grid xs={2}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%">
                                    قیمت محصول
                            </Box>
                            </Grid>
                            <Grid xs={3}>
                                <Box
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%">
                                    موجودی
                                <br />
                                    <Grid justify="center" container>
                                        <Grid xs={4}>250گرمی</Grid>
                                        <Grid xs={4}>
                                            <Box
                                                style={{
                                                    borderLeft: "0.2px solid #fff",
                                                    borderRight: "1px solid #fff",
                                                }}>
                                                500گرمی
                                        </Box>
                                        </Grid>
                                        <Grid xs={4}>1000گرمی</Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                            <Grid xs={2}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%">
                                    محتوای عربی
                            </Box>
                            </Grid>
                            <Grid xs={1}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%">
                                    عملیات
                            </Box>
                            </Grid>
                        </Grid>
                    </Box>
                    {(pageLoading) ? (
                        <Box mt={3}>
                            <Loader text="در حال بارگزاری..." />
                        </Box>
                    ) : (
                        (productList.length > 0) ? (
                            (productList.map((item) => {
                                return (
                                    <ScrollableAnchor keepLastAnchorHash={false} id={`p${item.id}`}>
                                        <Box
                                            p={2}
                                            bgcolor="#fff"
                                            borderRadius={15}
                                            mt={1}
                                            textAlign="center">
                                            <Grid container>
                                                <Grid xs={2}>
                                                    <img width="40%" src={item.imgURL} />
                                                </Grid>
                                                <Grid xs={2}>
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        height="100%">
                                                        {item.title}
                                                    </Box>
                                                </Grid>
                                                <Grid xs={2}>
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        height="100%">
                                                        {item.price250}
                                                    </Box>
                                                </Grid>
                                                <Grid xs={3}>
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        height="100%">
                                                        {(item.bulkSale) ? (
                                                            <Grid justify="center" container>
                                                                <Grid xs={4}>{item.numberInStock250}</Grid>
                                                                <Grid xs={4}>
                                                                    <Box
                                                                        style={{
                                                                            borderLeft: "0.2px solid #818181",
                                                                            borderRight: "1px solid #818181",
                                                                        }}>
                                                                        {item.numberInStock500}
                                                                    </Box>
                                                                </Grid>
                                                                <Grid xs={4}>{item.numberInStock1000}</Grid>
                                                            </Grid>
                                                        ) : (
                                                            item.numberInStock250
                                                        )}
                                                    </Box>
                                                </Grid>
                                                <Grid xs={2}>
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        height="100%">
                                                        <input
                                                            type="checkbox"
                                                            checked={item.arContent}
                                                            disabled />
                                                    </Box>
                                                </Grid>
                                                <Grid xs={1}>
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        height="100%">
                                                        <a onClick={null}>
                                                            <DeleteForeverIcon
                                                                className={classes.cursor}
                                                                style={{ fill: "#950000" }}
                                                                onClick={() => handleClickOpen(item.id)} />
                                                        </a>
                                                        {(searchedKeyword !== '') ? (
                                                            <Link to={`/profile/products-edit/${item.id}/?&backurl=${history.location.pathname}?keyword=${searchedKeyword}&producttoland=${item.id}`}><EditIcon color="primary" /></Link>
                                                        ) : (
                                                            <Link to={`/profile/products-edit/${item.id}/?&backurl=${history.location.pathname}/?producttoland=${item.id}`}><EditIcon color="primary" /></Link>
                                                        )}
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </ScrollableAnchor>
                                )
                            })
                            )
                        ) : (
                            <Box mt={3} mb={1}>
                                <AlertMessage variant="info">
                                    موردی جهت نمایش وجود ندارد.
                            </AlertMessage>
                            </Box>
                        )
                    )}
                    <Box
                        display="flex"
                        justifyContent="center"
                        mt={2}
                        mb={2}
                        alignItems="center">
                        {(pages !== undefined && pages > 1) && (
                            <Grid style={{ margin: "0px auto" }}>
                                <Grid
                                    justify="center"
                                    alignItems="center"
                                    item
                                    md={12}
                                    xs={12}>
                                    <Box
                                        boxShadow={0}
                                        border={0}
                                        p={1}
                                        m={2}
                                        borderColor="#f2f2f2"
                                        className={classes.grayBox}>
                                        <Pagination
                                            count={Number(pages)}
                                            defaultPage={Number(reqPageNumber)}
                                            page={Number(reqPageNumber)}
                                            variant="outlined"
                                            shape="rounded"
                                            onChange={handleChangePage} />
                                    </Box>
                                </Grid>
                            </Grid>
                        )}
                    </Box>
                </Box>
            </Box>
            <Snackbar
                open={alert.open}
                autoHideDuration={4000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={toggleCloseAlert}>
                <Alert onClose={toggleCloseAlert} severity={alert.type}>
                    {alert.message}
                </Alert>
            </Snackbar>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description">
                <DialogTitle id="alert-dialog-slide-title">
                    آیا از حذف این محصول اطمینان دارید؟
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description"></DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Box
                        textAlign="center"
                        justifyContent="center"
                        alignItems="center"
                        display="flex"
                        width="100%">
                        <Button variant="contained" onClick={handleClose} color="secondary">
                            انصراف
                        </Button>
                        &nbsp;&nbsp;&nbsp;
                        <Button
                            className={classes.btnRed}
                            variant="contained"
                            onClick={deleteProduct}>
                            {deleteLoading ? (<CircularProgress size={25} color="inherit" />) : (<> <DeleteForeverIcon />حذف</>)}
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ProductsList
